module.exports = __webpack_public_path__ + "static/media/快速涂鸦简笔画.cef0b81e.png";